import cn from "classnames";
import { Fragment } from "react";
import { NavLink } from "react-router-dom";
import { tokens } from "./tokens";

export const CRUMB_VARIANTS = {
  UPPERCASE: "uppercase",
} as const;

export type CrumbVariant = (typeof CRUMB_VARIANTS)[keyof typeof CRUMB_VARIANTS];

export type Crumb = {
  name: string;
  to: string | null;
  label?: string;
  crumbVariant?: CrumbVariant;
};

const navLink = ({ isActive }: { isActive: boolean }) =>
  cn(
    "text-xl",
    "text-gray-900",
    "focus:text-gray-900",
    "font-semibold",
    { [tokens.type.link]: !isActive },
    { [tokens.type.link]: isActive },
  );

export function Breadcrumbs({ crumbs }: { crumbs: Crumb[] }) {
  return (
    <nav aria-label="Breadcrumb">
      <table>
        <tbody>
          <tr>
            {crumbs.map((crumb, idx) => (
              <Fragment key={`label-${crumb.name}-${idx}`}>
                <td className="p-0 align-bottom">
                  {crumb.label ? (
                    <span
                      className={cn(
                        "select-none text-xs font-semibold text-gray-500 tracking-wide",
                        {
                          uppercase:
                            crumb.crumbVariant === CRUMB_VARIANTS.UPPERCASE,
                        },
                      )}
                    >
                      {crumb.label}
                    </span>
                  ) : null}
                </td>
                {idx !== crumbs.length - 1 ? <td className="p-0" /> : null}
              </Fragment>
            ))}
          </tr>
          <tr>
            {crumbs.map((crumb, idx) => (
              <Fragment key={`name-${crumb.name}-${idx}`}>
                <td className="p-0 align-bottom pr-1.5">
                  {crumb.to === null ? (
                    <span className="text-xl font-semibold break-words">
                      {crumb.name}
                    </span>
                  ) : (
                    <NavLink className={navLink} to={crumb.to}>
                      {crumb.name}
                    </NavLink>
                  )}
                </td>
                {idx !== crumbs.length - 1 ? (
                  <td className="p-0 pr-1.5 align-bottom">
                    <span className="text-xl text-gray-400">/</span>
                  </td>
                ) : null}
              </Fragment>
            ))}
          </tr>
        </tbody>
      </table>
    </nav>
  );
}
